export const faqData = [
  {
    question: '蘑菇视频在线观看需要下载App吗？',
    answer: '不需要！蘑菇视频在线观看是完全基于浏览器的在线视频平台，您无需下载任何App或插件，打开浏览器即可随时随地畅享高清视频内容。我们支持Chrome、Safari、Edge等主流浏览器。',
  },
  {
    question: '蘑菇视频支持哪些分辨率播放？',
    answer: '蘑菇视频在线观看平台支持多种分辨率选择，包括720P高清、1080P全高清、4K超高清以及部分精选内容的8K极清画质。系统会根据您的网络状况自动推荐最佳分辨率，您也可以手动切换。',
  },
  {
    question: '蘑菇视频在线观看是否完全免费？',
    answer: '是的，蘑菇视频在线观看平台的核心视频内容完全免费向所有用户开放。我们致力于为广大用户提供优质、便捷的免费在线视频观看服务，让每个人都能轻松享受高清视听体验。',
  },
  {
    question: '如何在手机上观看蘑菇视频？',
    answer: '蘑菇视频在线观看支持多终端访问，您可以在手机浏览器中直接打开我们的网站，体验专为移动端优化的响应式界面。无论使用iOS还是Android设备，都能获得流畅的观看体验。',
  },
  {
    question: '蘑菇视频的内容多久更新一次？',
    answer: '蘑菇视频在线观看平台每日更新海量内容，涵盖纪录片、科技、影视、教育、美食、旅游等多个领域。我们与众多优质内容创作者合作，确保您每天都能发现新鲜有趣的高清视频。',
  },
  {
    question: '观看视频时卡顿怎么办？',
    answer: '如果您在观看过程中遇到卡顿，建议尝试以下方法：1）手动切换至较低分辨率；2）检查网络连接是否稳定；3）清除浏览器缓存后重试；4）尝试使用其他浏览器。蘑菇视频采用先进的CDN加速技术，通常能保证流畅播放。',
  },
  {
    question: '蘑菇视频支持哪些设备？',
    answer: '蘑菇视频在线观看平台全面支持PC电脑、平板、智能手机等多种设备。我们采用响应式设计，无论您使用哪种屏幕尺寸，都能获得最佳的观看体验。同时支持投屏功能，可将视频投射到大屏电视上观看。',
  },
  {
    question: '如何在蘑菇视频上找到想看的内容？',
    answer: '您可以通过多种方式在蘑菇视频上发现精彩内容：1）使用顶部搜索栏直接搜索关键词；2）浏览首页的分类导航；3）查看精选推荐和热门榜单；4）在分类页面按类别筛选。我们的智能推荐系统还会根据您的观看偏好推荐相关内容。',
  },
];